import React, { useEffect, useRef, useState } from "react";
import { IFeature, IProjectConfig } from "../../../../interface/interfaces";
import { DashboardLayout } from "../../Dashboard/DashboardLayout";
import { SpacingCustom } from "../../../layout/Spacing/SpacingCustom";
import { DashboardLayoutGridAndRows } from "../../Dashboard/DashboardLayoutGridAndRows";
import { useAppDispatch } from "../../../../redux/hooks";
import { Modal } from "../../Modal/Modal";
import { ProjectAdminListItemCard } from "../ProjectAdminConfigCard/ProjectAdminListItemCard";
import { closeModal, openModal } from "../../Modal/modal.slice";
import { Input } from "../../../shared/Input/Input";
import { FlexCenter } from "../../../layout/FlexCenter/FlexCenter";
import { addFeature, modifyProjectItem } from "../projectFeatureListFastUpdate.slice";
import { ProjectFeatureModalWrapper } from "./ProjectFeatureModalWrapper";
import { AddFeatureModalItem } from "./AddFeatureModalItem";

interface IProjectFeatureListMainProps {
    projectFeatureList: IProjectConfig[]   
}

export const ProjectFeatureListMain: React.FC<IProjectFeatureListMainProps> = ({projectFeatureList}) => {

    const formRef = useRef<HTMLFormElement | null>(null);
    const [label, setLabel] = React.useState<string>('');
    const [errorLabel, setErrorLabel] = useState<string>('');

    const [tool, setTool] = useState<string>('');
    const [errorTool, setErrorTool] = useState<string>('');
    const [featureName, setFeatureName] = useState<string>('');
    const [defaultLocation, setDefaultLocation] = useState<string>('');
    const [parameter, setParameter] = useState<string>('');
    const [description, setDescription] = useState<string>('');

    const dispatch = useAppDispatch();
    const [selectedItem, setSelectedItem] = React.useState<IProjectConfig | null>(null);

    
    // Edit department
    const onEditItemOpenModal = (item: IProjectConfig)=>{
        setLabel(item.Label)
        setErrorLabel('')
        setSelectedItem(item)
        dispatch(openModal("adminPanelChangeItemModal"))
    }

    // Add feature
    const onAddFeatureOpenModal = (item: IProjectConfig)=>{
        setErrorTool('')
        setSelectedItem(item)
        dispatch(openModal("adminPanelAddFeatureModal"))
    }

    // Edit feature



    const onSubmitInput = (e: React.FormEvent<HTMLFormElement>)=>{
        e.preventDefault()

        if(label.trim() === ""){
            setErrorLabel(`Department name can't be empty.`);
            return;
        }
        
        if (selectedItem?.DepartmentId !== undefined) {
            dispatch(modifyProjectItem({DepartmentId: selectedItem.DepartmentId, Label: label}))
        } else {
            setErrorLabel('Department ID is missing.');
        }
        
        dispatch(closeModal("adminPanelChangeItemModal"))
        setLabel("")
        setErrorLabel('')
    }

    const onSubmitAddFeature = (e: React.FormEvent<HTMLFormElement>)=>{
        e.preventDefault()

        const feature: IFeature = {
            Tool: tool,
            FeatureName: featureName,
            DefaultLocation: defaultLocation,
            Parameter: parameter,
            Description: description
        }

        if(tool.trim() === ""){
            setErrorTool(`Department Tool can't be empty.`);
            return;
        }

        if (selectedItem?.DepartmentId !== undefined) {
            dispatch(addFeature({DepartmentId: selectedItem.DepartmentId, Feature: feature}));
        } else {
            setErrorTool('Department ID is missing.');
        }

        dispatch(closeModal("adminPanelAddFeatureModal"))
        setTool('')
        setFeatureName('')
        setDefaultLocation('')
        setParameter('')
        setDescription('')
    }

    const onDepartmentLabelInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>)=>{
        setLabel(e.target.value)
    }

    const onChangeAddFeature = (setter: React.Dispatch<React.SetStateAction<string>>) => 
        (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
          setter(e.target.value);
      };

    const projectFeatureListJSX = projectFeatureList.map((item: IProjectConfig, idx: number)=>{
        return (
            <div key={idx} style={{width:'100%'}} className="animation-3">
                <ProjectAdminListItemCard item={item} onEditItemOpenModalFunc={onEditItemOpenModal} onAddFeatureOpenModalFunc = {onAddFeatureOpenModal}/>
            </div>
        )
    })
    
    return (
        <>
            <Modal modalKey="adminPanelAddFeatureModal">
                <ProjectFeatureModalWrapper titleDistance={2} titleSize={1.5} formRef={formRef} error={errorTool} iconName={"Add_green"} textLabel={"Add feature"} hasTextAccent = {false} textAccent={selectedItem?.Label} func={onSubmitAddFeature}>
                    <div style={{width:'600px'}}>
                        <FlexCenter direction="h" position="start" gap={1}>
                            <AddFeatureModalItem label={"Tool"} value={tool} placeholder={"Tool"} formRef={formRef} func={onChangeAddFeature(setTool)}/>
                            <AddFeatureModalItem label={"Feature Name"} value={featureName} placeholder={"Feature name"} formRef={formRef} func={onChangeAddFeature(setFeatureName)}/>
                            <AddFeatureModalItem label={"Default Location"} value={defaultLocation} placeholder={"Default location"} formRef={formRef} func={onChangeAddFeature(setDefaultLocation)}/>
                            <AddFeatureModalItem label={"Parameter"} value={parameter} placeholder={"Parameter"} formRef={formRef} func={onChangeAddFeature(setParameter)}/>
                            <AddFeatureModalItem label={"Description"} value={description} placeholder={"Description"} formRef={formRef} func={onChangeAddFeature(setDescription)}/>
                        </FlexCenter>
                    </div>
                </ProjectFeatureModalWrapper>
            </Modal>

            <Modal modalKey="adminPanelChangeItemModal">
                <ProjectFeatureModalWrapper formRef={formRef} error={errorLabel} iconName={"Edit_green"} textLabel={"Edit department name:"} textAccent={selectedItem?.Label} func={onSubmitInput}>
                    <Input placeholder="...department name" formRef={formRef} func={(e)=>onDepartmentLabelInputChange(e)} value={label.toString()}/>
                </ProjectFeatureModalWrapper>
            </Modal>
            <DashboardLayout>
                <SpacingCustom paddingTop={1}>
                    <DashboardLayoutGridAndRows display={"row"}>
                        {projectFeatureListJSX}
                    </DashboardLayoutGridAndRows>
                </SpacingCustom>
            </DashboardLayout>
        </>
    )
}
